import { APP_ID, isDevMode, NgModule, signal } from '@angular/core';
import { AgrBrowserModule } from '@next/core-lib/browser';
import { ENVIRONMENT_MAPPER } from '@next/core-lib/environment-browser';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';

import { AppComponent } from './app.component';
import { AppModule } from './app.module';
import { parsePlanetProofEnvironment } from './shared/util/parse-environment';

declare global {
  var CONFIG_BUILD_ID: string | undefined;
}

const loadedConfig = signal(environment);

export const setupRuntimeConfig = (async () => {
  try {
    const buildId = globalThis.CONFIG_BUILD_ID;
    const configUrl = buildId ? `/assets/config.json?v=${buildId}` : '/assets/config.json';
    const response = await fetch(configUrl);
    if (response.ok) {
      const config = await response.json();
      loadedConfig.set({ ...environment, ...parsePlanetProofEnvironment(config) });
      console.log('Runtime configuration loaded successfully');
    } else {
      console.warn('No runtime configuration found, using default environment settings.');
    }
  } catch (e) {
    console.warn('Failed to load runtime environment variables', e);
  }
})();

@NgModule({
  imports: [AppModule, AgrBrowserModule],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: ENVIRONMENT_MAPPER,
      useFactory: () => {
        return loadedConfig();
      },
    },
    {
      provide: APP_ID,
      useFactory: () => loadedConfig().APPLICATION_NAME,
    },
    provideStore(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),
    provideEffects(),
    provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode in production
      autoPause: true, // Pauses recording actions when extension window is not open
      trace: false, // Stack trace for actions
      traceLimit: 75, // Maximum stack trace frames
      connectInZone: false, // Connect outside Angular zone to prevent unnecessary change detection
    }),
  ],
})
export class AppBrowserModule {}
